import { xmlTMSSelectCMRActionsXML } from '../../../pb-screen/models/TMSSelectCMRActions.interface';
import { ToScreenService } from '../../../pb-screen/services/to-screen.service';
import { TransportOrder } from '../../../pb-screen/models/transport-order/transport-order.interface';
import { OnInit, Component, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { select } from '@angular-redux/store';
import { ApplicationUser, DocumentToBePrinted } from '../../../pb-screen/models/application.user.interface';
import { ModalType } from '../../../shared/models/source';
import { SharedActions } from '../../../shared/shared.actions';
import { SharedService } from '../../../shared/services/shared.service';
import { GetCmrActionsService } from '../../../pb-screen/services/getCmrActions.service';
import { PrintService } from '../../../shared/services/print/print.service';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { takeUntil } from 'rxjs/operators';
import { PlanningBlock } from '../../../pb-screen/models/planning-block/planning-block.interface';
import { Observable, Subject } from 'rxjs/Rx';


@Component({
    moduleId: module.id,
    selector: 'print-list-modal',
    templateUrl: './print-list-modal.component.html'
})
export class PrintlistComponent extends SimpleModalComponent<TransportOrder, void> implements  OnInit, OnDestroy {
  @ViewChild('modal') public modal: ElementRef;

  @select('applicationUser') public applicationUser$: Observable<ApplicationUser>;
  @select('selectedTransportOrders') public selectedTransportOrders$: Observable<TransportOrder[]>;
  @select('processedDisplayState') public processedDisplayState$: Observable<boolean>;
  @select('filteredPlanningBlocks') public filteredTransportOrder$: Observable<TransportOrder[]>;
  @select('selectedPbsFromPlanBoard') selectedPbsFromPlanBoard$: Observable<PlanningBlock[]>;


  public selectedTransportOrders: TransportOrder[] = [];
  private selectedTransportOrder: TransportOrder;

  public selectedList = '';

  public overMaximum = false;
  public sizeOfSelectionToBig = false;

  public applicationUser: ApplicationUser;

  public modalType = ModalType;

  public weekPlanStartDate: string;
  public weekPlanEndDate: string;

  private processedTransportOrder: TransportOrder[];
  private processedDisplayState: boolean;

  public enableAutocomplete = false;

  public printButtonRestriction = false;
  public documentsList: string[];


  private destroy$ = new Subject();


  constructor(
    private sharedActions: SharedActions,
    private toScreenService: ToScreenService,
    private sharedService: SharedService,
    private getCmrActionsService: GetCmrActionsService,
    private printService: PrintService
  ) {
    super();
  }

  ngOnInit() {
    this.subscribeToApplicationUser();
    this.subscribeToSelectedTransportOrders();
    this.subscribeToSelectedPbsFromPlanBoard();
    this.subscribeToProcessedDisplayState();
    this.setPrintButtonRestriction();
    this.setDocumentList();
  }


  closeModal() {
    this.close();
    this.resetUi();
  }

  selectionChanged() {
    this.sizeOfSelectionToBig = false;
    this.overMaximum = false;
    this.printButtonRestriction = false;

    if (this.selectedList === 'Cmr') {
      this.sharedActions.getCmrActions(this.selectedTransportOrder.id);
    } else if (this.selectedList === 'Transport Order Document') {
      this.printButtonRestriction = !this.selectedTransportOrder;
    }
  }

  checkSize() {
    if (this.selectedList === 'Cmr' || this.selectedList === 'Transport Order Document') {
      this.print();
      return;
    }


    this.overMaximum = this.processedTransportOrder.length > 750;
    this.sizeOfSelectionToBig = this.processedTransportOrder.length > 250 && !this.overMaximum;
    this.printButtonRestriction = this.sizeOfSelectionToBig || this.overMaximum;

    if (this.sizeOfSelectionToBig || this.overMaximum) {
      return;
    }


    this.print();
  }

  print() {
    if (this.selectedList === 'Transport Order Document') {
      this.printService.printtransportorder(this.selectedTransportOrder.id);
      this.closeModal();
    } else if (this.selectedList === 'Cmr') {
      this.sharedService.myUpdatedObject.tmsSelectCMRActions.forEach(CmrAction => {
        if (CmrAction.select[0] !== '0') {
          const xmlTMSCmrObject: xmlTMSSelectCMRActionsXML = {
            tmsSelectCMRActions: [CmrAction],
            Text               : ''
          };

          CmrAction.select[0] = 'true';

          this.getCmrActionsService.printCmrDocument(
            xmlTMSCmrObject,
            this.selectedTransportOrder.planningBlocks[0].id,
            this.selectedTransportOrder.id
          );
        }
      });
    }
  }

  private setPbs(data: PlanningBlock[]) {
    const noData = data?.length < 1;

    if (noData) {
      return;
    }


    this.toScreenService.getTransportOrdersByIds(data[0].transportOrderNumber).subscribe(toData => {
      this.selectedTransportOrder = toData[0];
      this.selectedTransportOrders = [this.selectedTransportOrder];

      if (this.selectedTransportOrder) {
        this.toScreenService.getPlanningBlocksForTO(this.selectedTransportOrder.id).subscribe(to => {
          this.selectedTransportOrder.planningBlocks = to.planningBlocks;
          this.sharedActions.getPbsForTO(to.planningBlocks);
        });
      }
    });
  }

  private subscribeToApplicationUser() {
    this.applicationUser$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(applicationUser => {
      if (applicationUser) {
        this.applicationUser = applicationUser;
        this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
      }
    });
  }

  private subscribeToSelectedTransportOrders() {
    this.selectedTransportOrders$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(transportOrders => {
      if (transportOrders.length > 0) {
        this.selectedTransportOrder = Object.assign({}, transportOrders[0]);
        this.selectedTransportOrders = [this.selectedTransportOrder];

        if (this.selectedTransportOrder) {
          this.toScreenService.getPlanningBlocksForTO(this.selectedTransportOrder.id).subscribe(to => {
            this.selectedTransportOrder.planningBlocks = to.planningBlocks;
            this.sharedActions.getPbsForTO(to.planningBlocks);
          });
        }
      }
    });
  }

  private subscribeToSelectedPbsFromPlanBoard() {
    this.selectedPbsFromPlanBoard$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(data => this.setPbs(data));
  }

  private subscribeToProcessedDisplayState() {
    this.processedDisplayState$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(processedDisplayState => this.processedDisplayState = processedDisplayState);
  }

  private setPrintButtonRestriction() {
    if (this.selectedList === '') {
      this.printButtonRestriction = true;
    }
  }

  private setDocumentList() {
    if (!this.applicationUser) {
      return;
    }


    let screenList: DocumentToBePrinted[];

    if (this.sharedService.ScreenName === 'to-screen') {
      screenList = this.applicationUser.Screens.toscreen;
    } else {
      screenList = this.applicationUser.Screens.todetails;
    }

    this.documentsList = screenList.map(screen => screen.name);
  }

  private resetUi() {
    this.sharedActions.setUiState(true);
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
